import { extend } from 'dayjs';
import localeData from 'dayjs/plugin/localeData';
import { setDayjsLocale } from '../locales/dayjs';

/**
 * 设置Day.js
 */
export function setupDayjs() {
  extend(localeData);

  setDayjsLocale();
}
